export default "__VITE_ASSET__70d4902b__"